import { WriterSalesGraphTypeEnum } from '@interfaces/WriterSalesGraphTypeEnum'
import { Expose, Type } from 'class-transformer'
import { SalesAnalyticsDataEbookTableType } from './SalesAnalyticsDataEbookTableType'
import { SalesAnalyticsGraphDataType } from './SalesAnalyticsGraphDataType'

export class SalesAnalyticsDetailEbookDataType {
  @Expose()
  @Type(() => SalesAnalyticsDataEbookTableType)
  tableData: SalesAnalyticsDataEbookTableType[]

  @Expose()
  @Type(() => SalesAnalyticsGraphDataType)
  graphData: SalesAnalyticsGraphDataType[]

  @Expose()
  graphType: WriterSalesGraphTypeEnum
}
